import module from 'empresa/module.js'

export default class EmpresaConfiguracionRegistroPatronalHistorialService {
  constructor ($http) {
    this.$http = $http
  }

  post (empresaId, registroPatronalId, data) {
    return this.$http.post('/api/empresa/configuracion/registro-patronal/historial', data, {
      params: {empresaId, registroPatronalId},
    })
  }
}

module.service('EmpresaConfiguracionRegistroPatronalHistorial', EmpresaConfiguracionRegistroPatronalHistorialService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Configuracion/RegistroPatronal/Historial.js